import CommonProgress from './CommonProgress.vue'
export default CommonProgress
